import { render, staticRenderFns } from "./txAccSelect.vue?vue&type=template&id=0b8d9560"
import script from "./txAccSelect.vue?vue&type=script&lang=js"
export * from "./txAccSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports